<template>
    <div class="row">
        <router-view></router-view>
    </div>
</template>

<script>

export default {
    name: "CountryComponent",
};
</script>

<style scoped>

</style>
